import React from 'react'
import "./ImagesCustomScroll.css"

const cardData = [
    {
        icon:"/images/icons/member-icon-1.png",
        title:'24/7 fast access to care',
        para:"Get medical support when and where you need it, with no waitlists or delays."
    },
    {
        icon:"/images/icons/member-icon-2.png",
        title:"Personalized Case Management",
        para:" A dedicated team that ensures continuity, coordination, and clarity across every touchpoint of your care."
    },
    {
        icon:"/images/icons/member-icon-3.png",
        title:"Focus on longevity and prevention",
        para:" We don’t just treat. We plan, prevent, and optimize long before symptoms arise."
    },
]

function ImagesCustomScroll() {
  return (
    <div className='ImagesCustomScroll-container standard-padding-space'>
        <div className='imgFlowWrapper d-flex align-items-center gap-3'>
           <div className="imgFlowTrack">
                {[1, 2].map((row, i) => (
                <React.Fragment key={i}>
                    <img src="/images/creatives/member-carousel-icon-1.png" alt="slider" className="img-fluid" style={{maxHeight:"300px",borderRadius:"20px"}}/>
                    <img src="/images/creatives/member-carousel-icon-2.png" alt="slider" className="img-fluid" style={{maxHeight:"300px",borderRadius:"20px"}}/>
                    <img src="/images/creatives/member-carousel-icon-3.png" alt="slider" className="img-fluid" style={{maxHeight:"300px",borderRadius:"20px"}}/>
                </React.Fragment>
                ))}
            </div>
        </div>
        <div className='container'>
            <div className='text-content text-center pt-5'>
                <h3 className='body-heading'>We're revolutionizing how <span className='color-blue'>care</span> is delivered</h3>

            </div>

            <div className='row gy-lg-0 gy-3 pt-4'>
                {cardData.map((ele)=>{
                    return(
                        <div className='col-lg-4 d-flex flex-column align-items-start px-5'>
                            <div className='blue-box my-3 p-2 d-flex align-items-center justify-content-center'>
                                <img src={ele?.icon} className='img-fluid' />
                            </div>
                                <h5 className='body-heading mb-1' style={{fontSize:"1.2rem"}}>{ele.title}</h5>
                                <p className='body-paragraph mb-0'>{ele.para}</p>
                        </div>  
                    )
                })}
              

            </div>
        </div>
    </div>

  )
}

export default ImagesCustomScroll